// Warm the JobDetailPage route chunk so the first /jobs/:id open shows content
// without waiting for the JS. The dynamic import resolves to the SAME module (and
// chunk) as App.js's `lazyWithRetry(() => import('./pages/JobDetailPage'))`, so
// webpack dedups — no new chunk. Memoized; failures reset so the next call retries
// and are swallowed (a prefetch must never surface an error).
let chunkPromise = null;

export function prefetchJobDetailChunk() {
  if (!chunkPromise) {
    chunkPromise = import('../../pages/JobDetailPage').catch(() => {
      chunkPromise = null;
    });
  }
  return chunkPromise;
}
